"use client";

import Icon from "@afa-shared/afa-components/dist/Icon";
import { usePathname } from "next/navigation";

import printButtonStyles from "./printButton.module.css";

export const PrintButton = () => {
  const pathName = usePathname() ?? "";
  const currentUrl = pathName;
  const showPrintButton =
    !currentUrl.includes("kundtjanst/skicka-meddelande") &&
    !currentUrl.includes("enkat") &&
    !currentUrl.includes("enkat/enkat-tacksida");
  return (
    showPrintButton && (
      <button className={printButtonStyles.printButtonContainer} onClick={() => print()}>
        <Icon name="print" size="sm" className={printButtonStyles.icon} /> Skriv ut
      </button>
    )
  );
};
